<template>
  <div class="main-title">
    <span>
      Quase lá, {{ user.name }}! <br />
      Sua solicitação foi enviada com sucesso. <br />
    </span>
    <span>
      Você receberá um e-mail <br />
      com a proposta em até 48h. <br />
    </span>
    <span>
      É simples! <br />
      Basta assinar eletronicamente para <br />
      iniciarmos a análise. <br />
    </span>
    <span>
      Após aprovação, será <br />
      encaminhada para solicitação. <br />
    </span>
    <span> Obrigado pela atenção! </span>
  </div>
</template>

<script>
import { saveSessionInfo } from "../../../../services/CoverService";

export default {
  name: "Final",
  props: {
    user: Object,
  },
  async created() {
    await saveSessionInfo({ hired: true });
  },
};
</script>

<style scoped>
.main-title {
  width: 100%;
  margin: 60px;
  font-style: normal;
  font-weight: 400;
  font-size: 35px;
  text-align: left;
  line-height: 1;
  letter-spacing: 0.15px;
  color: #292929;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.main-subtitle {
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 74px;
  text-align: right;
  letter-spacing: 0.15px;
  color: #292929;
}

.login-title {
  font-style: normal;
  font-weight: normal;
  font-size: 31px;
  line-height: 74px;
  letter-spacing: 0.15px;
  color: #39424e;
}

@media (max-width: 1164px) {
  .main-title {
    width: auto;
  }
}
</style>
